<template>
  <div class="side-bar-content">
    <div class="menu-content">
      <el-menu router :default-active="this.$route.path" class="menu-content">
        <div v-for="item in menu" :key="item.name">
          <!-- 如果子菜单是空则可以点击 -->
          <el-menu-item v-if="!item.children" :index="item.path">
            <img
              class="menu-icon"
              v-if="$route.path == '/'"
              :src="item.activeIcon"
              alt=""
              srcset=""
            />
            <img class="menu-icon" v-else :src="item.icon" alt="" srcset="" />
            <span>
              {{ item.name }}
            </span>
          </el-menu-item>

          <!-- 如果子菜单不为空则点击打开子菜单 -->

          <el-submenu
            v-else-if="item.children && item.children.length > 0"
            :index="item.index"
            :key="item.index"
          >
            <template slot="title">
              <!-- <i :class="item.icon"></i> -->
              <img class="menu-icon" :src="item.icon" alt="" srcset="" />
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                v-for="ch in item.children"
                :key="ch.path"
                :index="ch.path"
              >
                <span>
                  {{ ch.name }}
                </span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </div>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideMenu",
  methods: {},
  computed: {
    menu() {
      return this.filterMenu(
        this.projectConfig.LEFT_MENU,
        this.$store.state.permissions,
        this.$store.getters.isAdmin
      );
    },
  },
  data() {
    return {
      imgsrc: require("@/assets/images/icon_logo_yhe.png"),
    };
  },
  methods: {
    filterMenu(menus, permissions, isAdmin) {
      return (menus || [])
        .filter((m) => permissions.includes(m.code) || isAdmin)
        .map((m) => {
          const n = { ...m };
          if (m.children) {
            n.children = this.filterMenu(m.children, permissions, isAdmin);
          }
          return n;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.menu-content .imglogo {
  width: 100%;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: #fff;
    font-weight: 700;
    font-size: 18px;
    margin-top: 8px;
    margin-left: 5px;
  }
}

.side-bar-content {
  width: 100%;
  height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
}
.el-aside {
  background-color: #fff;
}
.menu-icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.menu-content {
  width: 100%;
  height: 100%;
  // background-color: #fff;
}
.el-menu-item.is-active {
  background-color: #165dff;
  color: #fff;
}
</style>
